/**
 * 环境判断服务
 * 以单例替代源工程的 Ioc/Injectable 依赖注入
 */
class EnvService {
    // node 生产环境
    get isProd() {
        return process.env.NODE_ENV === 'production';
    }

    // 正式线上环境
    get isProdOnline(): boolean {
        return process.env.IS_BUILD_ONLINE === 'true';
    }

    // 沙盒环境
    get isProdSandbox(): boolean {
        return process.env.IS_BUILD_ONLINE === 'false';
    }

    // 本地开发环境
    get isDev(): boolean {
        return !this.isProdOnline && !this.isProdSandbox;
    }

    get isClient(): boolean {
        return typeof window !== 'undefined';
    }

    get isServer(): boolean {
        return !this.isClient;
    }

    // 按环境选择：线上返回 online，其余（沙盒 / 开发）返回 sandbox
    pick<T>(online: T, sandbox: T): T {
        return this.isProdOnline ? online : sandbox;
    }
}

export const env = new EnvService();
